export default __webpack_public_path__ + "static/media/cyphr.9c165ca8.png";